module.exports = __webpack_public_path__ + "static/img/cop_sch_logo19.64d0cc5c.png";